import styles from './ProductDescriptionBlock.module.scss';
import { AccordionBlock } from '@/atoms/AccordionBlock';
import { Article } from '@/atoms/Article';
import { CharacteristicsType } from '@/types';

type ProductDescriptionBlockProps = {
  className?: string;
  characteristics: CharacteristicsType;
  productId: number;
};

export function ProductDescriptionBlock({
  className,
  characteristics,
  productId,
}: ProductDescriptionBlockProps) {
  if (!characteristics) return null;

  return (
    <AccordionBlock
      title="Описание и характеристики"
      className={className}
      content={
        <Article article={characteristics.article} productId={productId} />
      }
      withPreview
    >
      <div className={styles.content}>
        <p
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: characteristics.text }}
        />
        <div className={styles.params}>
          {characteristics.items.map((item) => (
            <div className={styles.param} key={item.value}>
              <p className={styles.paramName}>{item.name}</p>
              <p className={styles.paramValue}>{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </AccordionBlock>
  );
}
